import { CampoSeletorOption, CampoSeletorOptions } from "@/components/Formulario/CampoSeletor";
import Icon from "@/components/Icon";
import HBox from "@/components/layout/HBox";
import VBox from "@/components/layout/VBox";
import { mdiArrowRight } from "@mdi/js";
import styles from "./TrocarAtendente.module.css";
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth } from "@/lib/useAuth";
import { useState } from "react";

type Props = {
    currentUserId: number
    currentUserName: string
    selectedUserId?: string | null
    selectedGroupId?: string | null
    selectedUserGroupId?: string | null
    onSelectedUserChange?: (userId: string | null, userGroupId?: string | null) => void
    onSelectedGroupChange?: (groupId: string | null) => void
}

export const TrocarAtendente = ({
    currentUserId: currentUserId,
    currentUserName: currentUserName,
    selectedUserId: atendenteSelecionado,
    selectedGroupId: departamentoSelecionado,
    selectedUserGroupId: grupoDoUsuarioSelecionado,
    onSelectedUserChange: setAtendenteSelecionado,
    onSelectedGroupChange: setDepartamentoSelecionado,
}: Props) => {
    const { user } = useAuth();

    const [atendSearch, setAtendSearch] = useState("");

    const queryUsuarios = useQuery<any[]>('usuario', async () => {
        const result = await axios.get('/api/usuario/box');
        return result.data?.result;
    });

    const atendentes =
        queryUsuarios?.data
            ?.filter((it: any) => it.id != currentUserId)
            ?.reduce(
                (acc: CampoSeletorOption[], it: any) => {
                    if (it.grupos) {
                        for (const g of it.grupos) {
                            if (g.aceita_atendimento === false) continue;
                            acc.push(
                                ({
                                    id: it.id.toString(),
                                    label: it.nome,
                                    group: g.nome,
                                    groupId: g.id.toString(),
                                }) as CampoSeletorOption
                            )
                        }
                    }
                    return acc
                },
                [],
            )?.sort((a: CampoSeletorOption, b: CampoSeletorOption) => `${a.group}--${a.label}`.localeCompare(`${b.group}--${b.label}`)) ?? [];

    const queryGrupos = useQuery<any[]>('usuario_grupo', async () => {
        const result = await axios.get('/api/usuario_grupo/box');
        return result.data?.result;
    });



    return (
        <VBox gap="16px">
            <div className={styles.box}>
                <HBox style={{ width: '100%', justifyContent: 'space-between' }}>
                    <VBox style={{ width: 'auto' }} center>
                        <div style={{ color: 'var(--tc-color-primary)' }}>
                            Atendente atual
                        </div>
                        <div>
                            {currentUserName ?? currentUserId
                                ? currentUserId == user.id
                                    ? user.nome + ' (você)'
                                    : queryUsuarios?.data?.find(
                                        it =>
                                            it.id?.toString() == currentUserId?.toString(),
                                    )?.nome
                                : '(Não identificado)'}
                        </div>
                    </VBox>
                    <Icon
                        path={mdiArrowRight}
                        size={1.5}
                        color="var(--tc-color-primary)"
                    />
                    {departamentoSelecionado && (
                        <VBox style={{ width: 'auto' }} center>
                            <div style={{ color: 'var(--tc-color-primary)' }}>
                                Departamento
                            </div>
                            <div>
                                {queryGrupos.data?.find(it => it.id === +departamentoSelecionado)
                                    ?.nome ?? '(Selecione abaixo)'}
                            </div>
                        </VBox>
                    )}
                    {!departamentoSelecionado && (
                        <VBox style={{ width: 'auto' }} center>
                            <div style={{ color: 'var(--tc-color-primary)' }}>
                                Novo atendente
                            </div>
                            <div>
                                {atendenteSelecionado
                                    ? atendentes.find(it => it.id === atendenteSelecionado)
                                        ?.label
                                    : '(Selecione abaixo)'}
                            </div>
                        </VBox>
                    )}
                </HBox>
            </div>

            <div
                style={{
                    width: '100%',
                    height: '100%',
                    border: '1px solid var(--tc-color-gray-300)',
                    borderRadius: '8px',
                    padding: '8px',
                }}
            >
                <CampoSeletorOptions
                    value={atendentes}
                    selectedId={atendenteSelecionado ?? null}
                    selectedGroupId={departamentoSelecionado ?? null}
                    onSelect={(value, groupId) => {
                        setAtendenteSelecionado?.(value, groupId ?? null);
                        setDepartamentoSelecionado?.(null);
                    }}
                    onGroupSelect={value => {
                        setAtendenteSelecionado?.(null, null);
                        setDepartamentoSelecionado?.(value);
                    }}
                    search={atendSearch}
                    onChangeSearch={setAtendSearch}
                />
            </div>
        </VBox>
    )
}